/**
 * Spot FX pairs. GENERATED — do not edit.
 *
 * Written by `tooling/fx-registry.mts` from the venue's own instrument
 * metadata. Regenerate with `pnpm fx:registry` when a venue adds a pair.
 *
 * `tickValue` and `pointValue` are zero on every row, and deliberately: an FX
 * pip is worth an amount that depends on lot size and on the account's own
 * currency, resolved at fill time against a rate. See `valuation.ts` and the
 * exemption in `registry.ts`'s validation. Zero here is not a missing number,
 * it is the statement that a fixed one would be a lie.
 *
 * `tickSize` is the last displayed decimal place, taken from the venue's
 * `displayPrecision`. `pipValue` reads a pip as ten ticks, which gives 0.0001
 * on a five-decimal pair and 0.01 on a three-decimal yen pair — so the yen
 * exception is carried by the data rather than by a branch in the code.
 *
 * Source: Oanda v20 `/v3/accounts/{id}/instruments`, 68 CURRENCY instruments,
 * fetched 2026-08-21.
 */
import type { Spec } from './registry.js';

export const FX_PAIRS: readonly Spec[] = [
  { root: 'AUDCAD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Australian Dollar / Canadian Dollar', quantityStep: '0.01',
    base: 'AUD', quote: 'CAD', contractSize: '100000', currency: 'CAD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'AUDCHF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Australian Dollar / Swiss Franc', quantityStep: '0.01',
    base: 'AUD', quote: 'CHF', contractSize: '100000', currency: 'CHF',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'AUDHKD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Australian Dollar / Hong Kong Dollar', quantityStep: '0.01',
    base: 'AUD', quote: 'HKD', contractSize: '100000', currency: 'HKD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'AUDJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Australian Dollar / Japanese Yen', quantityStep: '0.01',
    base: 'AUD', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'AUDNZD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Australian Dollar / New Zealand Dollar', quantityStep: '0.01',
    base: 'AUD', quote: 'NZD', contractSize: '100000', currency: 'NZD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'AUDSGD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Australian Dollar / Singapore Dollar', quantityStep: '0.01',
    base: 'AUD', quote: 'SGD', contractSize: '100000', currency: 'SGD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'AUDUSD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Australian Dollar / US Dollar', quantityStep: '0.01',
    base: 'AUD', quote: 'USD', contractSize: '100000', currency: 'USD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'CADCHF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Canadian Dollar / Swiss Franc', quantityStep: '0.01',
    base: 'CAD', quote: 'CHF', contractSize: '100000', currency: 'CHF',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'CADHKD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Canadian Dollar / Hong Kong Dollar', quantityStep: '0.01',
    base: 'CAD', quote: 'HKD', contractSize: '100000', currency: 'HKD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'CADJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Canadian Dollar / Japanese Yen', quantityStep: '0.01',
    base: 'CAD', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'CADSGD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Canadian Dollar / Singapore Dollar', quantityStep: '0.01',
    base: 'CAD', quote: 'SGD', contractSize: '100000', currency: 'SGD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'CHFHKD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Swiss Franc / Hong Kong Dollar', quantityStep: '0.01',
    base: 'CHF', quote: 'HKD', contractSize: '100000', currency: 'HKD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'CHFJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Swiss Franc / Japanese Yen', quantityStep: '0.01',
    base: 'CHF', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'CHFZAR', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Swiss Franc / South African Rand', quantityStep: '0.01',
    base: 'CHF', quote: 'ZAR', contractSize: '100000', currency: 'ZAR',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURAUD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Australian Dollar', quantityStep: '0.01',
    base: 'EUR', quote: 'AUD', contractSize: '100000', currency: 'AUD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURCAD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Canadian Dollar', quantityStep: '0.01',
    base: 'EUR', quote: 'CAD', contractSize: '100000', currency: 'CAD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURCHF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Swiss Franc', quantityStep: '0.01',
    base: 'EUR', quote: 'CHF', contractSize: '100000', currency: 'CHF',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURCZK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Czech Koruna', quantityStep: '0.01',
    base: 'EUR', quote: 'CZK', contractSize: '100000', currency: 'CZK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURDKK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Danish Krone', quantityStep: '0.01',
    base: 'EUR', quote: 'DKK', contractSize: '100000', currency: 'DKK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURGBP', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / British Pound', quantityStep: '0.01',
    base: 'EUR', quote: 'GBP', contractSize: '100000', currency: 'GBP',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURHKD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Hong Kong Dollar', quantityStep: '0.01',
    base: 'EUR', quote: 'HKD', contractSize: '100000', currency: 'HKD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURHUF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Hungarian Forint', quantityStep: '0.01',
    base: 'EUR', quote: 'HUF', contractSize: '100000', currency: 'HUF',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Japanese Yen', quantityStep: '0.01',
    base: 'EUR', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURNOK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Norwegian Krone', quantityStep: '0.01',
    base: 'EUR', quote: 'NOK', contractSize: '100000', currency: 'NOK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURNZD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / New Zealand Dollar', quantityStep: '0.01',
    base: 'EUR', quote: 'NZD', contractSize: '100000', currency: 'NZD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURPLN', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Polish Zloty', quantityStep: '0.01',
    base: 'EUR', quote: 'PLN', contractSize: '100000', currency: 'PLN',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURSEK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Swedish Krona', quantityStep: '0.01',
    base: 'EUR', quote: 'SEK', contractSize: '100000', currency: 'SEK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURSGD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Singapore Dollar', quantityStep: '0.01',
    base: 'EUR', quote: 'SGD', contractSize: '100000', currency: 'SGD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURTRY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / Turkish Lira', quantityStep: '0.01',
    base: 'EUR', quote: 'TRY', contractSize: '100000', currency: 'TRY',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURUSD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / US Dollar', quantityStep: '0.01',
    base: 'EUR', quote: 'USD', contractSize: '100000', currency: 'USD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'EURZAR', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Euro / South African Rand', quantityStep: '0.01',
    base: 'EUR', quote: 'ZAR', contractSize: '100000', currency: 'ZAR',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPAUD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / Australian Dollar', quantityStep: '0.01',
    base: 'GBP', quote: 'AUD', contractSize: '100000', currency: 'AUD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPCAD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / Canadian Dollar', quantityStep: '0.01',
    base: 'GBP', quote: 'CAD', contractSize: '100000', currency: 'CAD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPCHF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / Swiss Franc', quantityStep: '0.01',
    base: 'GBP', quote: 'CHF', contractSize: '100000', currency: 'CHF',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPHKD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / Hong Kong Dollar', quantityStep: '0.01',
    base: 'GBP', quote: 'HKD', contractSize: '100000', currency: 'HKD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / Japanese Yen', quantityStep: '0.01',
    base: 'GBP', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPNZD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / New Zealand Dollar', quantityStep: '0.01',
    base: 'GBP', quote: 'NZD', contractSize: '100000', currency: 'NZD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPPLN', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / Polish Zloty', quantityStep: '0.01',
    base: 'GBP', quote: 'PLN', contractSize: '100000', currency: 'PLN',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPSGD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / Singapore Dollar', quantityStep: '0.01',
    base: 'GBP', quote: 'SGD', contractSize: '100000', currency: 'SGD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPUSD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / US Dollar', quantityStep: '0.01',
    base: 'GBP', quote: 'USD', contractSize: '100000', currency: 'USD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'GBPZAR', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'British Pound / South African Rand', quantityStep: '0.01',
    base: 'GBP', quote: 'ZAR', contractSize: '100000', currency: 'ZAR',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'HKDJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Hong Kong Dollar / Japanese Yen', quantityStep: '0.01',
    base: 'HKD', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'NZDCAD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'New Zealand Dollar / Canadian Dollar', quantityStep: '0.01',
    base: 'NZD', quote: 'CAD', contractSize: '100000', currency: 'CAD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'NZDCHF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'New Zealand Dollar / Swiss Franc', quantityStep: '0.01',
    base: 'NZD', quote: 'CHF', contractSize: '100000', currency: 'CHF',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'NZDHKD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'New Zealand Dollar / Hong Kong Dollar', quantityStep: '0.01',
    base: 'NZD', quote: 'HKD', contractSize: '100000', currency: 'HKD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'NZDJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'New Zealand Dollar / Japanese Yen', quantityStep: '0.01',
    base: 'NZD', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'NZDSGD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'New Zealand Dollar / Singapore Dollar', quantityStep: '0.01',
    base: 'NZD', quote: 'SGD', contractSize: '100000', currency: 'SGD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'NZDUSD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'New Zealand Dollar / US Dollar', quantityStep: '0.01',
    base: 'NZD', quote: 'USD', contractSize: '100000', currency: 'USD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'SGDCHF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Singapore Dollar / Swiss Franc', quantityStep: '0.01',
    base: 'SGD', quote: 'CHF', contractSize: '100000', currency: 'CHF',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'SGDJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Singapore Dollar / Japanese Yen', quantityStep: '0.01',
    base: 'SGD', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'TRYJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'Turkish Lira / Japanese Yen', quantityStep: '0.01',
    base: 'TRY', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDCAD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Canadian Dollar', quantityStep: '0.01',
    base: 'USD', quote: 'CAD', contractSize: '100000', currency: 'CAD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDCHF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Swiss Franc', quantityStep: '0.01',
    base: 'USD', quote: 'CHF', contractSize: '100000', currency: 'CHF',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDCNH', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Chinese Yuan (offshore)', quantityStep: '0.01',
    base: 'USD', quote: 'CNH', contractSize: '100000', currency: 'CNH',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDCZK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Czech Koruna', quantityStep: '0.01',
    base: 'USD', quote: 'CZK', contractSize: '100000', currency: 'CZK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDDKK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Danish Krone', quantityStep: '0.01',
    base: 'USD', quote: 'DKK', contractSize: '100000', currency: 'DKK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDHKD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Hong Kong Dollar', quantityStep: '0.01',
    base: 'USD', quote: 'HKD', contractSize: '100000', currency: 'HKD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDHUF', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Hungarian Forint', quantityStep: '0.01',
    base: 'USD', quote: 'HUF', contractSize: '100000', currency: 'HUF',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Japanese Yen', quantityStep: '0.01',
    base: 'USD', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDMXN', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Mexican Peso', quantityStep: '0.01',
    base: 'USD', quote: 'MXN', contractSize: '100000', currency: 'MXN',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDNOK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Norwegian Krone', quantityStep: '0.01',
    base: 'USD', quote: 'NOK', contractSize: '100000', currency: 'NOK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDPLN', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Polish Zloty', quantityStep: '0.01',
    base: 'USD', quote: 'PLN', contractSize: '100000', currency: 'PLN',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDSEK', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Swedish Krona', quantityStep: '0.01',
    base: 'USD', quote: 'SEK', contractSize: '100000', currency: 'SEK',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDSGD', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Singapore Dollar', quantityStep: '0.01',
    base: 'USD', quote: 'SGD', contractSize: '100000', currency: 'SGD',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDTHB', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Thai Baht', quantityStep: '0.01',
    base: 'USD', quote: 'THB', contractSize: '100000', currency: 'THB',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDTRY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / Turkish Lira', quantityStep: '0.01',
    base: 'USD', quote: 'TRY', contractSize: '100000', currency: 'TRY',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'USDZAR', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'US Dollar / South African Rand', quantityStep: '0.01',
    base: 'USD', quote: 'ZAR', contractSize: '100000', currency: 'ZAR',
    tickSize: '0.00001', tickValue: '0', pointValue: '0', displayPrecision: 5,
    sessionTemplateId: 'fx_spot' },
  { root: 'ZARJPY', exchange: 'FX', kind: 'fx_spot', assetClass: 'fx',
    description: 'South African Rand / Japanese Yen', quantityStep: '0.01',
    base: 'ZAR', quote: 'JPY', contractSize: '100000', currency: 'JPY',
    tickSize: '0.001', tickValue: '0', pointValue: '0', displayPrecision: 3,
    sessionTemplateId: 'fx_spot' },
];
